import { __assign, __rest } from "tslib";
import React from 'react';
import cx from 'classnames';
import bcx from 'bem-classname';
import IconAlert from '../icons/Alert';
var componentClass = 'form-control';
function Input(props) {
    var _a = props.type, type = _a === void 0 ? 'text' : _a, _b = props.invalid, invalid = _b === void 0 ? false : _b, _c = props.readonly, readonly = _c === void 0 ? false : _c, _d = props.required, required = _d === void 0 ? false : _d, _e = props.disabled, disabled = _e === void 0 ? false : _e, _f = props.label, label = _f === void 0 ? '' : _f, id = props.id, _g = props.name, name = _g === void 0 ? '' : _g, _h = props.className, className = _h === void 0 ? '' : _h, _j = props.placeholder, placeholder = _j === void 0 ? '' : _j, value = props.value, onChange = props.onChange, addonLeft = props.addonLeft, addonRight = props.addonRight, addonTop = props.addonTop, onBlur = props.onBlur, onFocus = props.onFocus, otherProps = __rest(props, ["type", "invalid", "readonly", "required", "disabled", "label", "id", "name", "className", "placeholder", "value", "onChange", "addonLeft", "addonRight", "addonTop", "onBlur", "onFocus"]);
    var _k = React.useState(false), focused = _k[0], setFocused = _k[1];
    var handleFocus = function (e) {
        setFocused(true);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
    };
    var handleBlur = function (e) {
        setFocused(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
    };
    var addonRightValid = React.isValidElement(addonRight);
    var addonLeftValid = React.isValidElement(addonLeft);
    var addonTopValid = React.isValidElement(addonTop);
    var empty = !value;
    var inputClasses = cx(className, bcx(componentClass, 'input-container', {
        readonly: readonly,
        disabled: disabled,
        invalid: invalid,
        empty: empty,
    }));
    return (React.createElement("div", { className: componentClass },
        React.createElement("div", { className: cx('text--sm', bcx(componentClass, 'input-label-container')) },
            label && (React.createElement("label", { className: bcx(componentClass, 'input-label', { empty: empty, disabled: disabled, focused: focused }), htmlFor: id }, label)),
            addonTopValid && (React.createElement("div", { className: bcx(componentClass, 'input-addon', { disabled: disabled }) }, addonTop))),
        React.createElement("div", { className: inputClasses },
            addonLeftValid && (React.createElement("div", { className: cx('mr-3', bcx(componentClass, 'input-addon', { disabled: disabled })) }, addonLeft)),
            React.createElement("input", __assign({}, ((type === 'text' || type === 'email') && {
                maxLength: 255,
            }), otherProps, { type: type, id: id, className: bcx(componentClass, 'input', { disabled: disabled }), placeholder: placeholder, value: value, name: name, onChange: onChange, onFocus: handleFocus, onBlur: handleBlur }, (required && {
                required: required,
            }), (readonly && {
                readOnly: readonly,
            }), (disabled && {
                disabled: disabled,
            }))),
            invalid && (React.createElement("div", { className: cx('ml-3', bcx(componentClass, 'input-error-alert', { disabled: disabled })) },
                React.createElement(IconAlert, { size: "16" }))),
            addonRightValid && (React.createElement("div", { className: cx('ml-3', bcx(componentClass, 'input-addon', { disabled: disabled })) }, addonRight)))));
}
function HelperText(props) {
    var children = props.children, _a = props.disabled, disabled = _a === void 0 ? false : _a, _b = props.invalid, invalid = _b === void 0 ? false : _b;
    return (React.createElement("div", { className: cx('text--sm', bcx(componentClass, 'input-helper-text', { disabled: disabled, invalid: invalid })) }, children));
}
Input.HelperText = HelperText;
export { Input };
//# sourceMappingURL=Input.js.map